<template>
  <div>
    <vs-row>
      <vs-row vs-justify="space-around" vs-w="7">
        <vs-card class="mr-3" style="border-radius: 15px; background: #5f91b1">
          <vs-row>
            <vs-col>
              <h2 style="color: white">
                <vs-icon icon="device_thermostat" size="medium"></vs-icon>
                Temperature & Humidity
              </h2>
            </vs-col>
          </vs-row>
          <vs-col vs-type="flex" vs-justify="space-between" vs-w="12">
            <vs-card class="mr-3 mt-3" style="border-radius: 15px">
              <div slot="header">
                <vs-row>
                  <vs-col>
                    <h5>Temperature</h5>
                  </vs-col>
                </vs-row>
                <h2 class="mt-2 mr-3" align="center" style="color: #5f91b1">
                  {{ temp }} ํc
                </h2>
              </div>
            </vs-card>

            <vs-card class="mr-3 mt-3" style="border-radius: 15px">
              <div slot="header">
                <vs-row>
                  <vs-col>
                    <h5>Humidity</h5>
                  </vs-col>
                </vs-row>
                <h2 class="mt-2" align="center" style="color: #5f91b1">
                  {{ humid }} %
                </h2>
              </div>
            </vs-card>
          </vs-col>
        </vs-card>
      </vs-row>
      <vs-row vs-justify="space-around" vs-w="5">
        <vs-card class="mr-3" style="border-radius: 15px; background: #58b4a9">
          <vs-row>
            <vs-col>
              <h3 style="color: white">
                <vs-icon icon="directions_run" size="small"></vs-icon> PIR
                sensors
              </h3>
            </vs-col>
          </vs-row>
          <vs-col vs-type="flex" vs-justify="space-between" vs-w="12">
            <vs-card class="mr-3 mt-3" style="border-radius: 15px">
              <div slot="header">
                <vs-row>
                  <vs-col>
                    <h3 align="center">Room A</h3>
                  </vs-col>
                </vs-row>
                <h4 class="mt-3" align="center" style="color: #58b4a9">
                  {{ person1 }}
                </h4>
              </div>
            </vs-card>

            <vs-card class="mr-3 mt-3" style="border-radius: 15px">
              <div slot="header">
                <vs-row>
                  <vs-col>
                    <h3 align="center">Room B</h3>
                  </vs-col>
                </vs-row>
                <h4 class="mt-3" align="center" style="color: #58b4a9">
                  {{ person2 }}
                </h4>
              </div>
            </vs-card>
          </vs-col>
        </vs-card>
      </vs-row>
      <vs-row>
        <vs-row vs-justify="space-around" vs-w="7">
          <vs-card
            class="mr-3"
            style="border-radius: 15px; background: #f09a1b"
          >
            <vs-row>
              <vs-col>
                <h3 style="color: white">
                  <vs-icon icon="meeting_room" size="small"></vs-icon> Door
                  sensors status
                </h3>
              </vs-col>
            </vs-row>
            <vs-col vs-type="flex" vs-justify="space-between" vs-w="12">
              <vs-card class="mr-3 mt-3" style="border-radius: 15px">
                <div slot="header">
                  <vs-row>
                    <vs-col>
                      <h3 align="center">Door A</h3>
                    </vs-col>
                  </vs-row>
                  <h4 class="mt-3" align="center" style="color: #f09a1b">
                    {{ door1 }}
                  </h4>
                </div>
              </vs-card>

              <vs-card class="mr-3 mt-3" style="border-radius: 15px">
                <div slot="header">
                  <vs-row>
                    <vs-col>
                      <h3 align="center">Door B</h3>
                    </vs-col>
                  </vs-row>
                  <h4 class="mt-3" align="center" style="color: #f09a1b">
                    {{ door2 }}
                  </h4>
                </div>
              </vs-card>

              <vs-card class="mr-3 mt-3" style="border-radius: 15px">
                <div slot="header">
                  <vs-row>
                    <vs-col>
                      <h3 align="center">Door C</h3>
                    </vs-col>
                  </vs-row>
                  <h4 class="mt-3" align="center" style="color: #f09a1b">
                    {{ door3 }}
                  </h4>
                </div>
              </vs-card>
            </vs-col>
          </vs-card>
        </vs-row>

        <vs-row vs-justify="space-around" vs-w="5">
          <vs-card
            class="mr-3"
            style="border-radius: 15px; background: #32c040"
          >
            <vs-row>
              <vs-col>
                <h3 style="color: white">
                  <vs-icon icon="power" size="small"></vs-icon> Smart plugs
                  status
                </h3>
              </vs-col>
            </vs-row>
            <vs-col vs-type="flex" vs-justify="space-between" vs-w="12">
              <vs-card class="mr-3 mt-3" style="border-radius: 15px">
                <div slot="header">
                  <vs-row>
                    <vs-col>
                      <h3 align="center">Plug A</h3>
                    </vs-col>
                  </vs-row>
                  <h4 class="mt-3" align="center" style="color: #32c040">
                    {{ plug1 }}
                  </h4>
                </div>
              </vs-card>

              <vs-card class="mr-3 mt-3" style="border-radius: 15px">
                <div slot="header">
                  <vs-row>
                    <vs-col>
                      <h3 align="center">Plug B</h3>
                    </vs-col>
                  </vs-row>
                  <h4 class="mt-3" align="center" style="color: #32c040">
                    {{ plug2 }}
                  </h4>
                </div>
              </vs-card>
            </vs-col>
          </vs-card>
        </vs-row>
      </vs-row>
    </vs-row>
  </div>
</template>

<script>
export default {
  data: () => ({
    person1: "No motion detect",
    person2: "No motion detect",
    temp: 0,
    humid: 0,
    plug1: "Off",
    plug2: "Off",
    door1: "Close",
    door2: "Close",
    door3: "Close",
    timeout: null,
  }),
  methods: {
    async getsensor() {
      await this.$API.get("tuya/user/az1636621853987KvPSf").then((result) => {
        console.log(result.data);
        result.data.result.forEach((element) => {
          if (element.name == "PIR mini") {
            console.log(element.status[0].value);
            if (element.status[0].value == "none") {
              this.person1 = "No motion detect";
            } else if (element.status[0].value == "pir") {
              this.person1 = "Motion detect";
            }
          } else if (element.name == "WiFi PIR Detector") {
            console.log(element.status[2].value);
            if (element.status[2].value == "false") {
              this.person2 = "No motion detect";
            } else if (element.status[2].value == "true") {
              this.person2 = "Motion detect";
            }
          } else if (element.name == "Temperature and humidity sensor LCD") {
            console.log(element.status[0].value);
            console.log(element.status[2].value);
            this.temp = element.status[2].value / 100;
            this.humid = element.status[0].value / 100;
          } else if (element.name == "Door Sensor 1") {
            console.log(element.status[0].value);
            if (element.status[0].value == false) {
              this.door1 = "Close";
            } else if (element.status[0].value == true) {
              this.door1 = "Open";
            }
          } else if (element.name == "Door Sensor 2") {
            console.log(element.status[0].value);
            if (element.status[0].value == false) {
              this.door2 = "Close";
            } else if (element.status[0].value == true) {
              this.door2 = "Open";
            }
          } else if (element.name == "Contact Sensor") {
            console.log(element.status[0].value);
            if (element.status[0].value == false) {
              this.door3 = "Close";
            } else if (element.status[0].value == true) {
              this.door3 = "Open";
            }
          } else if (element.name == "Smart plug 1 - 10A") {
            console.log(element.status[0].value);
            if (element.status[0].value == false) {
              this.plug1 = "Off";
            } else if (element.status[0].value == true) {
              this.plug1 = "On";
            }
          } else if (element.name == "Smart plug 2- 10A ") {
            console.log(element.status[0].value);
            if (element.status[0].value == false) {
              this.plug2 = "Off";
            } else if (element.status[0].value == true) {
              this.plug2 = "On";
            }
          }
        });
      });
      this.timeout = setTimeout(() => {
        this.getsensor();
      }, 20 * 1000);
    },
  },
  mounted() {},
  created() {
    this.getsensor();
  },
};
</script>

<style>
</style>